import { RefreshCw, AlertCircle, Inbox, Clock, FilePlus, BarChart2 } from 'lucide-react';

export const WIDGET_GRID_COPY = Object.freeze({
  errors: {
    generic: 'Something went wrong. Please try again.',
    dashboardLoad: 'Error loading dashboard.',
    connectionIssue: 'Connection issue',
    connectionMessage:
      "This content couldn't be retrieved due to a network issue. Please try again.",
    systemError: 'System error',
    systemErrorMessage:
      "We couldn't process your request at the moment. Please retry.",
    somethingWentWrong: 'Something went wrong',
    unexpectedError:
      'An unexpected error occurred while loading this content. Please try again.',
  },
  states: {
    loadingDashboard: 'Loading dashboard...',
    noWidgets: 'No widgets configured.',
    noData: 'No data to display.',
    noActivityYet: 'No activity yet',
    noActivityMessage:
      'New interactions and updates will appear here automatically.',
    noNotesYet: 'No notes yet',
    noNotesMessage: 'Add notes to track preferences or key info.',
    noKpiData: 'No metric data available.',
  },
  actions: {
    retry: 'Retry',
    reload: 'Reload',
    create: 'Create',
    pin: 'Pin',
    info: 'Info',
    update: 'Update',
    expand: 'Expand',
    createNote: 'Create Note',
    options: 'Options',
    dragWidget: 'Drag widget',
    pinWidget: 'Mark as lock for users (cannot be removed by collaborators)',
    unpinWidget: 'Unlock widget for collaborators',
    removeWidget: 'Remove widget',
  },
});

const copy = WIDGET_GRID_COPY;

export const DEFAULT_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: RefreshCw,
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
    buttonVariant: 'secondary',
  },
  SYSTEM_ERROR: {
    icon: AlertCircle,
    title: 'Error',
    message: copy.errors.generic,
    buttonText: copy.actions.retry,
    buttonVariant: 'secondary',
  },
  EMPTY: {
    icon: Inbox,
    title: 'No data',
    message: copy.states.noData,
    showButton: false,
  },
});

export const ACTIVITY_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: RefreshCw,
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
    buttonVariant: 'secondary',
  },
  SYSTEM_ERROR: {
    icon: AlertCircle,
    title: copy.errors.systemError,
    message: copy.errors.systemErrorMessage,
    buttonText: copy.actions.retry,
    buttonVariant: 'secondary',
  },
  EMPTY: {
    icon: Clock,
    title: copy.states.noActivityYet,
    message: copy.states.noActivityMessage,
    showButton: false,
  },
});

export const NOTES_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: RefreshCw,
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
    buttonVariant: 'secondary',
  },
  SYSTEM_ERROR: {
    icon: AlertCircle,
    title: copy.errors.somethingWentWrong,
    message: copy.errors.unexpectedError,
    buttonText: copy.actions.retry,
    buttonVariant: 'secondary',
  },
  EMPTY: {
    icon: FilePlus,
    title: copy.states.noNotesYet,
    message: copy.states.noNotesMessage,
    buttonText: copy.actions.create,
    buttonVariant: 'primary',
    showButton: true,
  },
});

export const KPI_STATE_COPY = Object.freeze({
  CONNECTION_ERROR: {
    icon: RefreshCw,
    title: copy.errors.connectionIssue,
    message: copy.errors.connectionMessage,
    buttonText: copy.actions.reload,
    buttonVariant: 'secondary',
  },
  SYSTEM_ERROR: {
    icon: AlertCircle,
    title: copy.errors.systemError,
    message: copy.errors.systemErrorMessage,
    buttonText: copy.actions.retry,
    buttonVariant: 'secondary',
  },
  EMPTY: {
    icon: BarChart2,
    message: copy.states.noKpiData,
    showButton: false,
  },
});
